module.exports = __webpack_public_path__ + "media/images/logo-freee-247181edbe3351b75123dbdac862abf7.svg";